<a class="skip-to-main visually-hidden" href="#main-content">Skip to main content</a>
<header *ngIf="isImpersonating">
  <mat-toolbar class="impersonation-toolbar">
    <!-- The live region is always there while viewing as someone, so the warning is announced when it fills it
         (a region inserted together with its text is missed by some screen readers). -->
    <span class="impersonation-status" role="status">
      <span *ngIf="impersonationNotice.targetMissing$ | async" class="impersonation-warning">
        <mat-icon aria-hidden="true" class="impersonation-warning-icon">warning</mat-icon>
        The member of staff you are viewing as could not be found, so some information cannot be shown.
      </span>
    </span>
    <span class="user-info">Logged in as {{ user.userName }} : {{ user.jobRole }}</span>
    <button mat-stroked-button type="button" class="stop-impersonation" (click)="cancelImpersonation()">
      Stop impersonation
    </button>
  </mat-toolbar>
</header>
<mat-sidenav-container class="container" [style.marginTop.px]="mobileQuery.matches ? 56 : 0" autosize="true">
  <nav class="vision-sidenav" aria-label="Main navigation">
    <div class="vision-sidenav-buttons-container" style="height: 100%" *ngIf="isLoggedIn">
      <div class="vision-logo-wrapper">
        <img src="assets/menu/Logo.svg" alt="Vision logo" class="vision-logo" />
      </div>

      <!-- Sidebar Icons - Hidden on small screens -->
      <a class="vision-sidenav-buttons sidebar-only" routerLink="." (click)="activatedNavLink()" aria-label="Dashboard">
        <mat-icon
          matTooltip="Dashboard"
          matTooltipPosition="right"
          class="menu-icon"
          [ngClass]="{ 'menu-icon-selected': activeURL == '/' }"
          aria-hidden="true"
          >dashboard</mat-icon
        >
      </a>

      <a
        *ngIf="this.permissions.includes(this.SitePermissions.PartnerHomepageView)"
        class="vision-sidenav-buttons sidebar-only"
        routerLink="/dashboard/"
        (click)="activatedNavLink()"
        aria-label="Partner Homepage"
      >
        <mat-icon
          matTooltip="Partner Homepage"
          matTooltipPosition="right"
          class="menu-icon"
          [ngClass]="{ 'menu-icon-selected': activeURL == '/dashboard' }"
          aria-hidden="true"
          >home</mat-icon
        >
      </a>

      <a
        *ngIf="this.permissions.includes(this.SitePermissions.CmHomepageView)"
        class="vision-sidenav-buttons sidebar-only"
        routerLink="/cm-homepage/maytas"
        (click)="activatedNavLink()"
        aria-label="Contract Management"
      >
        <mat-icon
          matTooltip="Contract Management"
          matTooltipPosition="right"
          class="menu-icon"
          [ngClass]="{ 'menu-icon-selected': activeURL == '/cm-homepage' }"
          aria-hidden="true"
        >
          description
        </mat-icon>
      </a>

      <a
        *ngIf="this.permissions.includes(this.SitePermissions.BdHomepageView)"
        class="vision-sidenav-buttons sidebar-only"
        routerLink="/bd-homepage/"
        (click)="activatedNavLink()"
        aria-label="BD Homepage"
      >
        <mat-icon
          matTooltip="BD Homepage"
          matTooltipPosition="right"
          class="menu-icon"
          [ngClass]="{ 'menu-icon-selected': activeURL == '/bd-homepage' }"
          aria-hidden="true"
        >
          cases
        </mat-icon>
      </a>

      <a
        *ngIf="this.permissions.includes(this.SitePermissions.HsHomepageView)"
        class="vision-sidenav-buttons sidebar-only"
        routerLink="/hs-homepage/"
        (click)="activatedNavLink()"
        aria-label="H&amp;S Homepage"
      >
        <mat-icon
          matTooltip="H&S Homepage"
          matTooltipPosition="right"
          class="menu-icon"
          [ngClass]="{ 'menu-icon-selected': activeURL.includes('/hs-homepage') }"
          aria-hidden="true"
        >
          health_and_safety
        </mat-icon>
      </a>

      <a
        class="vision-sidenav-buttons sidebar-only"
        routerLink="/learner/learner-search"
        (click)="activatedNavLink()"
        aria-label="Learner"
      >
        <mat-icon
          matTooltip="Learner"
          matTooltipPosition="right"
          class="menu-icon"
          [ngClass]="{ 'menu-icon-selected': activeURL.includes('/learner/') }"
          aria-hidden="true"
          >school</mat-icon
        >
      </a>

      <a
        class="vision-sidenav-buttons sidebar-only"
        routerLink="employer/search"
        (click)="activatedNavLink()"
        aria-label="Employer"
      >
        <mat-icon
          matTooltip="Employer"
          matTooltipPosition="right"
          class="menu-icon"
          [ngClass]="{ 'menu-icon-selected': activeURL.includes('/employer') }"
          aria-hidden="true"
          >business</mat-icon
        >
      </a>

      <a
        *ngIf="this.permissions.includes(this.SitePermissions.ReportsView)"
        class="vision-sidenav-buttons sidebar-only"
        routerLink="/reports/index"
        (click)="activatedNavLink()"
        aria-label="Reports"
      >
        <mat-icon
          matTooltip="Reports"
          matTooltipPosition="right"
          class="menu-icon"
          [ngClass]="{ 'menu-icon-selected': activeURL.includes('/reports/') }"
          aria-hidden="true"
          >bar_chart</mat-icon
        >
      </a>

      <a
        class="vision-sidenav-buttons sidebar-only"
        routerLink="/attendance/authorisedAbsence"
        (click)="activatedNavLink()"
        aria-label="Attendance"
      >
        <mat-icon
          matTooltip="Attendance"
          matTooltipPosition="right"
          class="menu-icon"
          [ngClass]="{ 'menu-icon-selected': activeURL.includes('/attendance/') }"
          aria-hidden="true"
          >how_to_reg</mat-icon
        >
      </a>

      <a
        *ngIf="this.permissions.includes(this.SitePermissions.MarketingHomepageView)"
        class="vision-sidenav-buttons sidebar-only"
        routerLink="/marketing/schoolContacts"
        (click)="activatedNavLink()"
        aria-label="Marketing"
      >
        <mat-icon
          matTooltip="Marketing"
          matTooltipPosition="right"
          class="menu-icon"
          [ngClass]="{ 'menu-icon-selected': activeURL.includes('/marketing/') }"
          aria-hidden="true"
          >campaign</mat-icon
        >
      </a>

      <a
        *ngIf="this.permissions.includes(this.SitePermissions.DataDashboardHomepage)"
        class="vision-sidenav-buttons sidebar-only"
        routerLink="data-dashboard-homepage/counts"
        (click)="activatedNavLink()"
        aria-label="Data Dashboard"
      >
        <mat-icon
          matTooltip="Data Dashboard"
          matTooltipPosition="right"
          class="menu-icon"
          [ngClass]="{ 'menu-icon-selected': activeURL.includes('/data-dashboard-homepage/') }"
          aria-hidden="true"
          >insights</mat-icon
        >
      </a>

      <a
        class="vision-sidenav-buttons sidebar-only"
        routerLink="/staff/staff-dashboard"
        (click)="activatedNavLink()"
        aria-label="Staff"
      >
        <mat-icon
          matTooltip="Staff"
          matTooltipPosition="right"
          class="menu-icon"
          [ngClass]="{ 'menu-icon-selected': activeURL == '/staff/staff-dashboard' }"
          aria-hidden="true"
          >people_alt</mat-icon
        >
      </a>

      <div style="flex: 1"></div>

      <div class="nav-actions">
        <div class="vision-sidenav-buttons notification-nav-button">
          <button
            mat-icon-button
            matTooltip="Notifications"
            matTooltipPosition="right"
            routerLink="/notifications"
            (click)="activatedNavLink()"
            [attr.aria-label]="countUnread > 0 ? 'Notifications, ' + countUnread + ' unread' : 'Notifications'"
            class="notification-button"
          >
            <span class="notification-icon-wrapper">
              <mat-icon
                class="menu-icon"
                [ngClass]="{ 'menu-icon-selected': activeURL.includes('/notifications') }"
                aria-hidden="true"
              >
                notifications
              </mat-icon>
              <span *ngIf="countUnread > 0" class="notification-icon-badge" aria-hidden="true"></span>
            </span>
          </button>
        </div>

        <div class="vision-sidenav-buttons user-menu-wrapper">
          <button mat-icon-button [matMenuTriggerFor]="userOptions" aria-label="User menu">
            <div class="menu-user-icon">
              {{ initials }}
            </div>
          </button>
          <mat-menu #userOptions="matMenu">
            <!-- Navigation Items - Shown when sidebar icons are hidden -->

            <!-- User Options - Always shown -->
            <button mat-menu-item (click)="navigateToStatusPage()">
              <mat-icon class="matMenu-button">check_circle_outline</mat-icon>
              <span>Vision Status</span>
            </button>
            <button
              *ngIf="this.permissions.includes(this.SitePermissions.Admin)"
              mat-menu-item
              routerLink="/admin"
              (click)="activatedNavLink()"
            >
              <mat-icon class="matMenu-button">settings</mat-icon>
              <span>Admin</span>
            </button>
            <button *ngIf="isImpersonating" mat-menu-item (click)="cancelImpersonation()">
              <mat-icon class="matMenu-button">face</mat-icon>
              <span>Stop impersonation</span>
            </button>
            <button mat-menu-item routerLink="/about" (click)="activatedNavLink()">
              <mat-icon class="matMenu-button" aria-hidden="true">info</mat-icon>
              <span>About</span>
            </button>
            <button mat-menu-item (click)="logout()">
              <mat-icon class="matMenu-button">logout</mat-icon>
              <span>Logout</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </nav>

  <div class="page-container">
    <main id="main-content">
      <router-outlet (activate)="onActivate($event)" style="margin-top: 80px"></router-outlet>
    </main>
    <div class="centre-page" *ngIf="pageRefreshButton">
      <button mat-button color="warn" (click)="refreshPage()" cdkFocusInitial>Refresh page</button>
    </div>
    <footer class="bottom-right" aria-label="Feedback">
      <span *ngIf="isLoggedIn">
        <frill-widget>Widget</frill-widget>
      </span>
    </footer>
  </div>
</mat-sidenav-container>
